export default __webpack_public_path__ + "static/media/03_photo.84018a6c.jpeg";